import Vue from 'vue';
import Router from 'vue-router';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import store from '@/store';
import HtmlTitleManager from '@/utils/htmlTitleManager';

import routes from '../router/routes';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

const userIsAuthenticated = () => {
  return !(firebase.auth().currentUser === null);
};

const userIsAdmin = (store) => {
  return store.getters.userIsAdmin;
};

const userIsManager = (store) => {
  return store.getters.getUserIsManager;
};

const waitForStorageToBeReady = async (to, from, next) => {
  await store.restored;

  store.dispatch('setLoading', true);

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requireAdmin = to.matched.some((record) => record.meta.admin);
  const requireManager = to.matched.some((record) => record.meta.manager || false);
  const isAuthenticated = userIsAuthenticated(store);
  const isAdmin = userIsAdmin(store);
  const isManager = userIsManager(store);

  /*
    Caso o usuário abrir varias empresas em abas diferentes e em uma delas tenha sido clicado em deslogar,
    os dados ainda ficam salvos no VUEX em algumas abas e o tawk-to continua ativo, por esse motivo foi
    adicionado essa condição para limpar o vuex-persist e atualizar a tela 
  */
  if (document.title !== 'HEXA' && !isAuthenticated) {
    sessionStorage.clear();
    location.reload();
  }

  const routeReleasedForLite = to.matched.some((record) => record.meta.routeReleasedForLite);
  const siglaEmpresa = store.getters.getSiglaEmpresa;
  if (isAuthenticated && siglaEmpresa && siglaEmpresa == 'LITE' && !routeReleasedForLite) {
    return next({ name: 'Power Ups' });
  }

  store.dispatch('setLoading', false);
  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'Login' });
  } else if (requireAdmin && !isAdmin) {
    if (!(requireManager && isManager)) {
      // Caso o usuário seja "Gerente de Usuários", libera o acesso a rotas administrativas desde que as mesmas estejam configuradas como meta.manager = true
      return next('/');
    }
  }

  /* Verifica se a rota que o usuário quer ir está disponivel, comparando com os links contidos no objeto listaTodasFerramentas */
  let pathsFerramentasNaoLiberadas = [];
  const modulosPermissoes = store.getters.getModulosPerfisLiberados;
  const listaTodasFerramentas = modulosPermissoes.ferramentas;
  const listaFerramentasLiberadasPerfil = modulosPermissoes.ferramentas_liberadas;

  for (const categoria in listaTodasFerramentas) {
    listaTodasFerramentas[categoria].forEach((ferramentaLista) => {
      let pathLiberadoParaPerfilLogado = listaFerramentasLiberadasPerfil.some(
        (ferramentaL) => ferramentaL.id == ferramentaLista.id
      );

      if ((!ferramentaLista.status || !pathLiberadoParaPerfilLogado) && ferramentaLista.link_rota_principal_completo) {
        pathsFerramentasNaoLiberadas.push(ferramentaLista.link_rota_principal_completo);
      }
    });
  }

  if (to.matched && to.matched.length) {
    const matched = to.matched[to.matched.length - 1];
    let mainPathTo = matched.path;
    // Remove o caractere '/' do início do path da string
    mainPathTo = mainPathTo.replace(/^\//, '');

    if (pathsFerramentasNaoLiberadas.includes(mainPathTo)) {
      return next({ name: '_404 Error' });
    }
  }
  /* ---------------------------------------------------------------------------------------------------------------------------- */

  return next();
};

router.beforeEach(waitForStorageToBeReady);

router.afterEach(() => {
  HtmlTitleManager.changeTitle();
});

export default router;
